<template>
  <div class="two"> 
    <div v-for="row in rows" :key="row" class="labelbody">
      <p class="text-center">CYANOPROKARYOTA HERBARIUM SPECIMEN OF PABGI</p>


      <div>
        <div class="font-weight-bold">{{row.store}}</div>
        <!-- <div v-for="srow in row.species.rows.slice(1)" :key="srow"> {{ srow.species.name }} </div> -->
        <div v-for="col in meta.columns" :key="col">
          <base-geo-cell v-if = "col.fieldname === 'species'" v-bind="{mode:'labelprint', column:col, initValue:row[col.fieldname], meta:meta, rowobject:row}" v-model="row[col.fieldname]"/>
        </div>
      </div>

      <div class="d-flex flex-wrap">
        <span><point-widget v-bind="{mode:'view'}" v-model="row.coordinates"/></span> <span v-if="row.alt">. El.: {{row.alt}} m a.s.l. </span> 
      </div>
      <div class="d-flex flex-wrap">
        <span v-if="row.reserve">{{row.reserve}}.&nbsp;</span>
        <span v-if="row.country">{{row.country}}.&nbsp;</span>
        <span v-if="row.province">{{row.province}}.&nbsp;</span>
        <span v-if="row.location">{{row.location}}. </span>
      </div>

      <!-- Leg.:&nbsp<date-widget v-bind="{mode:'view'}" v-model="row.legdate" />&nbsp{{row.legname2}}<br>
      Det.:&nbsp<date-widget v-bind="{mode:'view'}" v-model="row.species.rows[0].detdate" />&nbsp{{row.species.rows[0].detname2}}<br> -->

    <div class="d-flex flex-wrap">
      Leg.:&nbsp<date-widget v-bind="{mode:'view'}" v-model="row.legdate" />&nbsp{{row.legname2}}<br>
    </div>
    <div class="d-flex flex-wrap" v-if = "row.species.rows[0] !== undefined">
      Det.:&nbsp<date-widget v-bind="{mode:'view'}" v-model="row.species.rows[0].detdate" />&nbsp{{row.species.rows[0].detname2}} <br>
    </div>



      <span v-if="row.legnum"> No {{row.legnum}} </span> <span v-if="row.localcollnumber">{{row.mainstorage.name}}-{{row.localcollnumber}}</span>
      <!-- <div class="text-right">LID: {{row.linkid}}</div> -->
      <div>- - - - - - - ✂ - - - - - - - </div>
      <p>&nbsp;</p>
    </div>
  </div>
</template>
<!--
<div class="text-right">{{row.mainstorage.name}} {{row.localcollnumber}}</div><br>


-->

<script>
import PointWidget from '@/components/widgets/PointWidget.vue';
import DateWidget from '@/components/widgets/DateWidget.vue';
export default {
  name: 'kpabg-cyano-print-page',
  components: {
    PointWidget,
    DateWidget,

  },
  props:['meta', 'rows'],
  data(){ 
    return {

    }
  },
  methods: {

  },

}
</script>

<style scoped>
@media print {
  .two {
    column-count: 2;
    gap: 1cm;
    column-rule: 1px dotted #666;
    font-family:'Times New Roman';
    font-size: 10px;
  }
  .one {
    column-count: 1;
    -webkit-column-count: 1;
    -moz-column-count: 1;
    font-family:'Times New Roman';
    font-size: 10px;
  }
  @page {
    margin: 0.5cm;
  }
  .labelbody {
    page-break-inside: avoid;
  }
}
</style>